/**
 * Toast 메시지 관련 유틸리티 함수
 * localStorage를 사용하여 페이지 전환 시 토스트 메시지를 전달합니다.
 */

export const TOAST_VALID_DURATION_MS = 5000;
export const TOAST_DEFAULT_DURATION_MS = 4000;

/**
 * localStorage에서 타임스탬프가 유효한 토스트 메시지를 가져옵니다.
 * @param {string} key - localStorage 키
 * @param {number} validDuration - 유효 시간 (ms)
 * @returns {string|null} - 유효한 토스트 메시지 또는 null
 */
export function getValidToastMessage(key, validDuration = TOAST_VALID_DURATION_MS) {
  const toastData = localStorage.getItem(key);
  if (!toastData) return null;

  try {
    const { message, timestamp } = JSON.parse(toastData);
    if (Date.now() - timestamp < validDuration) {
      return message;
    }
  } catch (e) {
    console.error(`[Toast] Failed to parse toast data for key: ${key}`, e);
  } finally {
    localStorage.removeItem(key);
  }

  return null;
}

/**
 * localStorage에 타임스탬프와 함께 토스트 메시지를 저장합니다.
 * @param {string} key - localStorage 키
 * @param {string} message - 토스트 메시지
 */
export function setToastMessage(key, message) {
  localStorage.setItem(
    key,
    JSON.stringify({
      message,
      timestamp: Date.now(),
    })
  );
}
